<div class="progress-bar">
  <label class="subtitle3">Step {{getCurrentStep()}}/{{steps.length}}</label>
  <div>
    <app-steps *ngFor="let step of steps"  [steps]="step"></app-steps>
  </div>
</div>
